<template>
  <!-- INNER BANNER AREA -->
  <div class="inner_banner">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-12">
          <h2>{{ slug }}</h2>
          <p>Book now and save up to 60% on Booking in advance today</p>
        </div>
      </div>
    </div>
  </div>
  <!-- INNER BANNER AREA -->

  <!-- LISTING FORM AREA -->
  <div class="form_listing banner_area">
    <div class="container">
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-12">
            <div class="left_form">
              <div class="form_wrpa">
                <div class="row">
                  <div class="col-md-6">
                    <div class="loop_fields">
                      <label style="position: absolute;z-index: 1;">Select Airport</label>
                      <select class="form-control" ref="airport_select" v-model="formSearch.airport_id" v-on:change="airportChange($event)" style="z-index: 2 !important;padding-top: 25px;position: relative;">
                        <option disabled selected hidden value="">Select</option>
                        <option v-for="airport in airports" v-bind:key="airport.id+','+airport.code" :value="airport.id+','+airport.code">{{ airport.name }}</option>
                      </select>
                      <img src="/images/map.svg" alt="map-1">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="loop_fields" v-on:click="checkDate($event,$refs.date_off)" data-open="0">
                          <label>Drop Off Date</label>
                          <Datepicker ref="date_off" :format="format"  v-model="formSearch.drop_off_date" @update:modelValue="handleDate" auto-apply :min-date="new Date()" :enable-time-picker="false" :clearable="false"></Datepicker>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="loop_fields">
                          <label style="position: absolute;z-index: 1;">Drop Off Time</label>
                          <select class="form-control" v-model="formSearch.drop_off_time" style="z-index: 2 !important;padding-top: 25px;position: relative;">
                            <template v-for="(n,i) in 24" v-bind:key="n">
                              <option :value="i+':00'">{{ i+':00' }}</option>
                              <option :value="i+':15'">{{ i+':15' }}</option>
                              <option :value="i+':30'">{{ i+':30' }}</option>
                              <option :value="i+':45'">{{ i+':45' }}</option>
                            </template>

                          </select>
                          <img src="/images/clock.svg" alt="clock">
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 order-1 order-md-0">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="loop_fields" v-on:click="$refs.phone_c.focus()">
                          <label>Phone No</label>
                          <input ref="phone_c" class="form-control" placeholder="Free SMS Alert" type="text" v-model="formSearch.phone_no">
                          <img src="/images/call.svg" alt="call">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="loop_fields" v-on:click="$refs.discount_c.focus()">
                          <label>Discount Code</label>
                          <input ref="discount_c" class="form-control" placeholder="Enter Discount Code" type="text" v-model="formSearch.discount_code" v-on:keypress="changeDiscount()" v-on:change="changeDiscount()">
                          <img src="/images/discount.svg" alt="discount">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 order-0 order-md-1">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="loop_fields" v-on:click="checkDate($event,$refs.up_date)" data-open="0">
                          <label>Pick Up Date</label>
                          <Datepicker ref="up_date" :format="format" v-model="formSearch.pick_up_date" auto-apply :min-date="formSearch.drop_off_date" :enable-time-picker="false" :clearable="false"></Datepicker>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="loop_fields">
                          <label style="position: absolute;z-index: 1;">Pick Up Time</label>
                          <select class="form-control" v-model="formSearch.pick_up_time" style="z-index: 2 !important;padding-top: 25px;position: relative;">
                            <template v-for="(n,i) in 24" v-bind:key="n">
                              <option :value="i+':00'">{{ i+':00' }}</option>
                              <option :value="i+':15'">{{ i+':15' }}</option>
                              <option :value="i+':30'">{{ i+':30' }}</option>
                              <option :value="i+':45'">{{ i+':45' }}</option>
                            </template>
                          </select>
                          <img src="/images/clock.svg" alt="clock">
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
              <div class="row">
                <div class="col-md-12">
                  <input class="btn btn_blue" type="submit" name="" value="COMPARE PRICES">
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- LISTING FORM AREA -->


  <div class="text-center work_wrap">
    <div class="container">
      <div class="row">
        <div class="col-md-12 title_wrap">
          <h2>How does it Work?</h2>
          <p>To increase ease of operations and better customer experience, <span style="text-transform: capitalize;">{{ slug }}</span> Airport Meet and Greet Parking service is fine-tuned to offer our customers<br> convenience and ease of use. Booking and using our Meet and Greet service is summed up in three simple steps, which are mentioned below:</p>
        </div>
      </div>

      <div class="row middle_title">
        <div class="col-md-12">
          <h2>Meet and greet is a simple and reliable process where all you need to do is:</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 ">
          <div class="loop_work">
            <img src="/images/booking.svg" alt="booking">
            <h2>Make a booking:</h2>
            <p>Use our website to schedule your<br> meet and greet parking.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="loop_work">
            <img src="/images/driver.svg" alt="driver">
            <h2>Call the Chauffeur:</h2>
            <p>Call the Chauffeur 20 minutes<br> before reaching the airport.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="loop_work">
            <img src="/images/keys.svg" alt="keys">
            <h2>Hand over the Keys:</h2>
            <p>Hand over your keys to the<br> chauffeur who will park your car<br> in a safe and secure location,<br> while you embark on your journey!</p>
          </div>
        </div>
      </div>



      <div class="row middle_title mag_top">
        <div class="col-md-12">
          <h2>When you return, the process is as elegantly simple as well, all you need to do is:</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="loop_work">
            <img src="/images/driver.svg" alt="driver">
            <h2>Call the Chauffeur.</h2>
            <p>As soon as you land and clear<br> security, call your<br> designated chauffeur.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="loop_work">
            <img src="/images/waiting.svg" alt="waiting
">
            <h2>Proceed to the pickup Point:</h2>
            <p>Head towards the designated<br> pickup point and wait for your<br> car.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="loop_work">
            <img src="/images/car.svg" alt="car
">
            <h2>Drive home Safe:</h2>
            <p>Collect your vehicle and drive<br> off to your home safely.</p>
          </div>
        </div>
      </div>
    </div>
  </div>



  <!-- TYPE WRAP AREA  -->
  <div class="type_wrap pink">
    <div class="container">
      <div class="row title">
        <div class="col-md-12">
          <h2>Overview</h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row wp">
        <div class="col-md-12">
          <div class="type_loop">
            <div v-html="description"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- TYPE WRAP AREA  -->

  <div class="steps_wrap table_wrap" v-if="companies.length > 0">
    <div class="container">
      <div class="row">
        <div class="col-md-12 title">
          <h2>Available Car Parks</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 scroll">
          <table class="table">
            <thead>
            <tr>
              <th>Car Parking</th>
              <th>Company</th>
              <th>Customer Rating</th>
              <th>Terminal</th>
              <th>8 Days Price</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="company in companies" v-bind:key="company.company_id">
              <td><img style="width:250px" :src="imageURL+company.image" :alt="company.company_name" /></td>
              <td>{{ company.company_name }}</td>
              <td>
                <ul class="nav justify-content-center">
                  <li v-for="rating in company.company_rating" v-bind:key="rating">
                    <template v-if="checkstar(rating,company.company_rating_show)">
                      <img src="/images/star-full.png" style="width: 17px" alt="full-star"/>
                    </template>
                    <template v-else>
                      <img src="/images/star-half.png" style="width: 17px" alt="half-star"/>
                    </template>
                  </li>
                  <li v-for="rating in 5 - company.company_rating" v-bind:key="rating">
                    <img src="/images/star4.png" style="width: 17px" alt="image-star4" />
                  </li>
                </ul>
              </td>
              <td class="terminal">
                <template v-for="terminal in company.terminals" v-bind:key="terminal.terminal_name">{{ terminal.terminal_name }}<span>,</span></template>
              </td>
              <td>£ {{ company.amount }}<br>
                <form v-bind:ref="'form_'+company.company_id"
                      v-on:submit.prevent="handleBookingSubmit('form_'+company.company_id)" method="post">
                  <input type="hidden" name="hiddenStarting_date_time" :value="company.drop_off_date">
                  <input type="hidden" name="hidden_Dep_time" :value="company.drop_off_time">
                  <input type="hidden" name="hidden_end_date" :value="company.pick_up_date">
                  <input type="hidden" name="hidden_arrival_time" :value="company.pick_up_time">
                  <input type="hidden" name="starting_date_time" :value="company.drop_off_date">
                  <input type="hidden" name="departure_time" :value="company.drop_off_time">
                  <input type="hidden" name="ending_date_time" :value="company.pick_up_date">
                  <input type="hidden" name="arrival_time" :value="company.pick_up_time">
                  <input type="hidden" name="discount_amount" :value="company.discount_amount">
                  <input type="hidden" name="discount_code" :value="company.discount_code">
                  <input type="hidden" name="airport" :value="company.airport_id">
                  <input type="hidden" name="airport_name" :value="company.airport_name">
                  <input type="hidden" name="plan_id" :value="company.plan_id">
                  <input type="hidden" name="company_id" :value="company.company_id">
                  <input type="hidden" name="amount" :value="company.total_amount">
                  <input type="hidden" name="company" :value="company.company_name">
                  <input type="hidden" name="day_diff" :value="company.day_difference">
                  <input type="hidden" name="image" :value="company.is_api ? company.image_url : imageURL+company.image">
                  <input type="hidden" value name="terms">
                  <input type="hidden" name="is_api" :value="company.is_api">
                  <input type="hidden" name="quote_id" :value="company.quote_id">
                  <input type="hidden" name="parking_type" :value="company.parking_type">
                  <input type="hidden" name="sms_confirmation" :value="formSearch.sms_confirmation">
                  <input type="hidden" name="cancellation_cover" :value="formSearch.cancellation_cover">
                  <input type="hidden" name="via" :value="'Airport'">
                  <button type="submit" value="BOOK NOW" class="btn btn_blue">Book Now</button>
                </form>
                </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "AirportComponent",
  computed: {
    slug() {
      return this.$route.params.slug;
    }
  },
  data() {
    return {
      airport_id: '',
      airports:{},
      companies:[],
      post: {},
      formSearch:{
        'airport_id':'',
        'drop_off_date':new Date(),
        'drop_off_time':"12:00",
        'pick_up_date':new Date(),
        'pick_up_time':"12:00",
        'phone_no':'',
        'discount_code':'',
      },
      description: "",
      is_market_discount:0,
      is_md:0, // second check market discount
      is_modified:0,
      formBookNow: {
        "hiddenStarting_date_time": "",
        "hidden_Dep_time": "",
        "hidden_end_date": "",
        "hidden_arrival_time": "",
        "starting_date_time": "",
        "departure_time": "",
        "ending_date_time": "",
        "arrival_time": "",
        "discount_amount": "",
        "discount_code": "",
        "day_difference": "",
        "airport": "",
        "airport_name": "",
        "plan_id": "",
        "company_id": "",
        "amount": "",
        "company": "",
        "day_diff": "",
        "image": "",
        "terms": "",
        "is_api": "",
        "quote_id": "",
        "parking_type": "",
        "sms_confirmation": "",
        "cancellation_cover": "",
        'expiry_time': moment(new Date).add(30, 'minutes').format('X'),
      },
    }
  },
  created() {
    // Retrieve the post data based on the slug value
    this.loadDescription();
    this.getAirports();
  },
  mounted() {
    console.log("Mounted");

    if (this.$route.query) {
      this.formSearch.discount_code = this.$route.query.offer_id
    }

    this.fetchMarketDiscount();
    this.changeDiscount();
    this.loadDescription();
    this.handleDate();
  },
  methods:{
    checkDate(evt,ev){
      if(evt.currentTarget.dataset.open == 1){
        ev.closeMenu();
        evt.currentTarget.dataset.open = 0
      }else{
        ev.openMenu()
        evt.currentTarget.dataset.open = 1
      }
    },
    loadDescription(){
      let name = ''
      var bName = '';

      if(this.slug.includes("luton")){
        this.airport_id = 1;
        this.formSearch.airport_id = '1,LTN';
        this.formSearch.airport_id = '1,null';
        name = "carparkingluton";
        bName = "car-parking-luton";
        console.log('1 airport selected')
      }
      else if(this.slug.includes("birmingham")){
        this.airport_id = 2;
        this.formSearch.airport_id = '2,BHX';
        this.formSearch.airport_id = '2,null';
        name = "carparkingbrmingum";
        bName = "carparkingbermingam";
        console.log('2 airport selected')

      }
      else if(this.slug.includes("manchester")){
        this.airport_id = 3;
        this.formSearch.airport_id = '3,MAN';
        this.formSearch.airport_id = '3,null';
        name = "carparkingmanchester";
        bName = "car-parking-manchester";
        console.log('3 airport selected')
      }
      else if(this.slug.includes("heathrow")){
        this.airport_id = 4;
        this.formSearch.airport_id = '4,LHR';
        this.formSearch.airport_id = '4,null';
        name = "carparkingheathrow";
        bName = "car-parking-heathrow";
        console.log('4 airport selected')

      }
      else if(this.slug.includes("gatwick")){
        this.airport_id = 5;
        this.formSearch.airport_id = '5,LGW';
        this.formSearch.airport_id = '5,null';
        name = "carparkinggatwick";
        bName = "car-parking-Gatwick";
        console.log('5 airport selected')
      }
      else if(this.slug.includes("stansted")){
        this.airport_id = 6;
        this.formSearch.airport_id = '6,STN';
        this.formSearch.airport_id = '6,null';
        name = "carparkingstansted";
        bName = "carparkingstansted";
        console.log('6 airport selected')
      }

      console.log(this.slug);
      let formData = {
        'id' : this.airport_id,
        'name' : name
      }

      let seoData = {'base_name': bName};
      if(bName != ''){
        try {




          this.axios.post('https://app.compareparkingprices.co.uk/api/index.php/home/getSEOInfo', seoData)
              .then(function (response) {
                if (response.status != undefined && response.data != "") {
                  document.title = response.data.data.seo_title != undefined ? response.data.data.seo_title : 'Compare Parking Prices';
                  document.querySelector('meta[name="title"]').content = response.data.data.seo_title
                  document.querySelector('meta[name="description"]').content = response.data.data.seo_description
                  document.querySelector('meta[name="keywords"]').content = response.data.data.seo_keyword

                }else{
                  document.title = 'Airport - Compare Parking Prices';

                }
              })
          // Navigate to the success route

        } catch (error) {
          // Navigate to the error route

        }
      }



      try {
        this.axios.post(this.apiURL+'/home/getAirportDetail', formData).then((response) => {
          console.log(this.companies);
          this.companies = response.data.companies;
          this.companies.sort(function(a, b) {
            return a.amount - b.amount;
          });

          this.description = response.data.data.pages_detail;
        })
        // Navigate to the success route

      } catch (error) {
        // Navigate to the error route

      }



    },
    async handleSubmit() {
      localStorage.setItem('formSearch', JSON.stringify(this.formSearch))
      this.$router.push({
        name: 'CompareRate',
      });
    },
      getAirports() {
      this.axios.get(this.apiURL + '/home/getAirports').then((response) => {
        this.airports = response.data.data;
      });
    },
    async airportChange(ev) {

      console.log(ev);

      let discountCode = this.$refs.airport_select.options[this.$refs.airport_select.selectedIndex].dataset.code;
      // It reprocess the code and checks for marketing discount....
      await this.fetchMD(this.formSearch.discount_code)


      /*if (this.$route.query && this.$route.query.offer_id != undefined && this.is_market_discount == 1 && this.is_modified == 0) {
        this.formSearch.discount_code = this.$route.query.offer_id
      } */

      if(this.is_md){
        // it will not reflect the entry
      }else {
        if(discountCode != null){
          this.formSearch.discount_code = discountCode;
        }
      }
    },
    fetchMarketDiscount(){
      if (this.$route.query && this.$route.query.offer_id != undefined) {
        let formData = {
          'offer_id': this.$route.query.offer_id
        }

        this.axios.post(this.apiURL + '/home/checkMarketingDiscount', formData).then((response) => {
          this.is_market_discount = response.data.data
        })
      }
    },

    fetchMD(code){
      let formData = {
        'offer_id': code
      }

      this.axios.post(this.apiURL + '/home/checkMarketingDiscount', formData).then((response) => {
        this.is_md = response.data.data;
        return;
      })
    },
    changeDiscount(){
      this.fetchMD(this.formSearch.discount_code)
    },
    handleDate() {
      let newDate = new Date(this.formSearch.drop_off_date);
      newDate.setDate(this.formSearch.drop_off_date.getDate() + 7)
      this.formSearch.pick_up_date = newDate;
    },
    format(date){

      return moment(date).format('ddd DD MMMM YYYY');
    },
    checkstar(rating,pointRating){

      let pRating = pointRating.toString().split(".");
      if (pRating[0] == rating) {
        if(pRating[1] < 5){
          return false;
        }else{
          return true;
        }
      } else {
        return true;
      }
    },
    handleBookingSubmit(reference) {
      const formBooking = this.$refs[reference];

      this.formBookNow.hiddenStarting_date_time = formBooking[0].elements.hiddenStarting_date_time.value;
      this.formBookNow.hidden_Dep_time = formBooking[0].elements.hidden_Dep_time.value;
      this.formBookNow.hidden_end_date = formBooking[0].elements.hidden_end_date.value;
      this.formBookNow.hidden_arrival_time = formBooking[0].elements.hidden_arrival_time.value;
      this.formBookNow.starting_date_time = formBooking[0].elements.starting_date_time.value;
      this.formBookNow.departure_time = formBooking[0].elements.departure_time.value;
      this.formBookNow.ending_date_time = formBooking[0].elements.ending_date_time.value;
      this.formBookNow.arrival_time = formBooking[0].elements.arrival_time.value;
      this.formBookNow.discount_amount = formBooking[0].elements.discount_amount.value;
      this.formBookNow.discount_code = formBooking[0].elements.discount_code.value;
      this.formBookNow.airport = formBooking[0].elements.airport.value;
      this.formBookNow.airport_name = formBooking[0].elements.airport_name.value;
      this.formBookNow.plan_id = formBooking[0].elements.plan_id.value;
      this.formBookNow.company_id = formBooking[0].elements.company_id.value;
      this.formBookNow.amount = formBooking[0].elements.amount.value;
      this.formBookNow.company = formBooking[0].elements.company.value;
      this.formBookNow.day_diff = formBooking[0].elements.day_diff.value;
      this.formBookNow.image = formBooking[0].elements.image.value;
      this.formBookNow.terms = formBooking[0].elements.terms.value;
      this.formBookNow.is_api = formBooking[0].elements.is_api.value;
      this.formBookNow.quote_id = formBooking[0].elements.quote_id.value;
      this.formBookNow.parking_type = formBooking[0].elements.parking_type.value;
      this.formBookNow.via = formBooking[0].elements.via.value;
      this.formBookNow.expiry_time = moment(new Date).add(30, 'minutes').format('X');


      localStorage.setItem('booking', JSON.stringify(this.formBookNow));
      console.log(`is_api = ${this.formBookNow.is_api}`)
      if(this.formBookNow.is_api == 1){
        this.$router.push({
          name: 'ApiBooking',
        });
      }else{
        this.$router.push({
          name: 'YourQuoteA',
        });
      }

    },
  },
  watch: {
    slug: function() {
      this.loadDescription();
    }
  }

}
</script>

<style scoped>
td.terminal span{ margin-right: 5px }
td.terminal span:last-child{ display:none;}
</style>